import axios from '@/utils/request';

const v2 = 'v2/circuit';
export const getMyMvms = () => axios.get(`${v2}/myMvms`);
